module.exports = __webpack_public_path__ + "img/step-by-step-close.7cfdfd30.svg";